import { createFileRoute } from '@tanstack/react-router';
import { BackendPage, getBackendPageUrl } from '@mews-commander/modules';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Job/Detail/$id')({
    component: BackendPageComponent,
    staticData: {
        owner: MewsTeam.Infrastructure,
        type: RouteType.Backend,
    },
});

function BackendPageComponent() {
    const { pathname, search } = Route.useMatch();

    return <BackendPage url={getBackendPageUrl({ pathname, search })} />;
}
